import { ServiceConfig } from '@user/store/services/config'

export const getActivityUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.activities.activities}`
